import styled from 'styled-components';

import Button from '@components/Button';
import theme from '@theme';

export const StyledButton = styled(Button)`
  &&& {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    min-width: 30px;

    @media (max-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
      position: absolute;
      left: 48%;
      top: 20px;
      z-index: 2;
      background-color: white !important;
      border: 1px solid ${({ theme }) => theme.palette.darkGrey} !important;
      border-radius: 4px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @media (max-width: ${({ theme }) => theme.breakPoint.TABLET}) {
      left: 47%;
    }

    @media (max-width: ${({ theme }) => theme.breakPoint.PHONE}) {
      left: 45%;
    }

    &:hover,
    &:active,
    &:focus {
      opacity: 0.8;
      background: transparent !important;
    }

    &:focus-visible {
      outline: none !important;
    }

    img {
      opacity: 0.8;
    }
  }
`;
export const Wrapper = styled.div<{ isListingPage?: boolean }>`
  width: ${({ isListingPage }) => (isListingPage ? '330px' : '234px')};
`;

export const WrapperMobile = styled.div<{ isListingPage?: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 6px;
  position: relative;
  background: white;

  @media (max-width: ${theme.breakPoint.WIDE_DESKTOP}) {
    width: 150px;
  }
  @media (max-width: ${theme.breakPoint.LARGE_1X}) {
    width: 100%;

    & > div {
      max-width: calc(50% - 4px);
    }
  }

  &:hover {
    background-color: white;
  }

  img {
    opacity: 0.8;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  position: relative;
`;
